/**
 *  Sticky Content
 *  Use jQuery
 */

;(function sticky($) {

    $(document).ready(init);

    var VERTICAL_BREAKPOINT = 610;
    var HORIZONTAL_BREAKPOINT = 1100;
    var stickyElements;
    var win;

    function init() {
        stickyElements = $('.js-Sticky');
        if (stickyElements.length !== 0) {
            //  Activate or not the sticky function on desktop
            win = $(window);
            win.on('scroll', debounce(updateSticky, 50));
        }
    }

    function updateSticky() {
        var width = win.width();
        var scroll = win.scrollTop();

        if(scroll >= VERTICAL_BREAKPOINT && width >= HORIZONTAL_BREAKPOINT) {
            stickyElements.attr('data-sticky', 'yes');
        } else {
            stickyElements.attr('data-sticky', 'no');
        }
    }

}(jQuery));
